import React, {useEffect, useState} from "react";
import Header from "../../components/Header.js";
import {FormattedMessage, FormattedNumber, IntlProvider} from 'react-intl';
import * as StorageService from "../../services/StorageService.js";
import {
    FIREBASE_SCREEN_NAMES,
    HEADER_SIZE,
    LOCALSTORAGE_ITEMS,
    ORDER_PLACE,
    PAYMENT_TYPES,
    procStatuses
} from "../../util/Constants.js";
import OrderReviewActionsBar from "../../components/Actionsbar/OrderReviewActionsBar";
import * as ProductService from "../../services/ProductService.js";
import Spinner from '../../components/Spinner.js';
import {EventBus} from "../../util/EventBus";
import QuantityModifier from "../../components/QuantityModifier";
import {
    addMinutes,
    getProdExtrasFromCart,
    getProdName,
    getProdOptionsFromCart,
    getProductsOrderFromCart
} from "../../util/common";
import {PATH} from "../../routes/routes.js";
import analyticsLogEvent from "../../services/FirebaseService";
import Moment from "react-moment";
import {DATE_FORMAT} from "../../util/DateUtil";
import ScanQrToContinue from "../../components/ScanQrToContinue";
import {useNavigate} from "react-router";
import {
    createGroupedOrdersHandler,
    getAllGroupedOrdersHandler,
    upsertGroupProductsOrderHandler
} from "../../handlers/HandlerProducts";

function OrderReview() {
    const navigateTo = useNavigate();
    const userTable = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TABLE) ? StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TABLE) : null;
    const shopDetails = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)) : null;
    const userInfoAnonymous =  StorageService.getItem(LOCALSTORAGE_ITEMS.USER_INFO_ANONYMOUS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.USER_INFO_ANONYMOUS)) : null;
    const allowedPaymentMethodsForTableOrder = shopDetails?.merchantConfig?.pmtMethodsForTable;
    const allowedPaymentMethodsForBarPickup = shopDetails?.merchantConfig?.pmtMethodsForBarPickup;
    const currency = shopDetails ? shopDetails.currency : null;
    const isBarPickup = shopDetails ? (typeof shopDetails.merchantConfig.barPickup !== "undefined" ? shopDetails.merchantConfig.barPickup : null) : false;
    const timeForBarPickup = shopDetails ? (typeof shopDetails.merchantConfig.timeForBarPickup !== "undefined" ? shopDetails.merchantConfig.timeForBarPickup : null) : false;
    const orderPlace = StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_PLACE) ? StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_PLACE) : null;
    const hasGroupOrdering = shopDetails ? (typeof shopDetails.merchantConfig.groupOrders !== "undefined" ? shopDetails.merchantConfig.groupOrders : null) : false;
    const userInfo = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_INFO) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.USER_INFO)) : null;
    const groupOrderIdInStorage = StorageService.getItem(LOCALSTORAGE_ITEMS.GROUP_ORDER_ID) ? StorageService.getItem(LOCALSTORAGE_ITEMS.GROUP_ORDER_ID) : null;
    const visible = "visible";
    const hidden = "hidden";

    const [state, setState] = useState({
        loading: false,
        isSubmitBtnEnabled: true,
        errorMsg: null,
        currentStyle: hidden,
        currentCart: StorageService.getItem(LOCALSTORAGE_ITEMS.CURRENT_CART) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.CURRENT_CART)) : null,
        outOfStockProducts: [],
        outOfStockExtras: [],
        genericError: false,
        openGroupOrders: null
    });

    let buttonClicked = false;


    useEffect(() => {
        if (!state.currentCart || (!userTable && isBarPickup === false)) {
            navigateTo(PATH.ALL_PRODUCTS);
        }

        analyticsLogEvent("screen_view", {
            firebase_screen: FIREBASE_SCREEN_NAMES.ORDER_REVIEW,
            firebase_screen_class: FIREBASE_SCREEN_NAMES.ORDER_REVIEW
        });
    }, []);

    useEffect(() => {
        if (state.currentCart && getProductsOrderFromCart(state.currentCart).length === 0) {
            navigateTo(PATH.ALL_PRODUCTS);
        }
    }, [state.currentCart]);

    useEffect(() => {
        if (state.genericError) {
            EventBus.dispatch("genericErrorMsg");
            setState({
                ...state,
                genericError: false
            });
        }
    }, [state.genericError])


    const getTotalProducts = (orderDetails) => {
        let totalProducts = 0;
        orderDetails?.forEach(product => {
            totalProducts += product.quantity;
        })
        return totalProducts;
    }

    const getTotalPrice = (orderDetails) => {
        let price = 0;
        orderDetails?.forEach(product => {
            product.choices.forEach(c => {
                price += c.price * c.quantity;
            });
        })
        return price;
    }

    const increaseQuantity = (product, choice) => {
        return function (e) {
            e.stopPropagation();
            const category = product.category;
            const newCart = {
                ...state.currentCart
            }
            let productEntry = newCart[category][product.name];
            if (productEntry) {
                productEntry = {
                    ...productEntry,
                    "quantity": productEntry.quantity + 1,
                }

                let choices = productEntry.choices;
                let found = false;

                choices.forEach(c => {
                    if (!found && c.option == choice.option && c.msg == choice.msg &&
                        (c.extras === choice.extras ||
                            c.extras != null && choice.extras != null &&
                            JSON.stringify(c.extras) === JSON.stringify(choice.extras))
                    ) {
                        c.quantity += 1;
                        found = true;
                        return;
                    }
                });

                if (found) {
                    newCart[category] = {
                        ...newCart[category],
                        [product.name]: productEntry
                    }
                }
            }

            StorageService.setItem(LOCALSTORAGE_ITEMS.CURRENT_CART, JSON.stringify(newCart));

            setState({
                ...state,
                currentCart: newCart
            })
        };
    }

    const decreaseQuantity = (product, choice) => {
        return function (e) {
            e.stopPropagation();
            const category = product.category;
            const newCart = {
                ...state.currentCart
            }
            let productEntry = newCart[category][product.name];
            if (productEntry) {
                if (productEntry.quantity > 1) {
                    productEntry = {
                        ...productEntry,
                        "quantity": productEntry.quantity - 1,
                    }

                    let choices = productEntry.choices;
                    let found = false;

                    for (let i = 0; i < choices.length; i++) {
                        const c = choices[i];
                        if (!found && c.option == choice.option && c.msg == choice.msg &&
                            (c.extras === choice.extras ||
                                c.extras != null && choice.extras != null &&
                                JSON.stringify(c.extras) === JSON.stringify(choice.extras))
                        ) {
                            c.quantity -= 1;
                            if (c.quantity == 0) {
                                choices.splice(i, 1);
                            }
                            found = true;
                            break;
                        }
                    }

                    if (found) {
                        newCart[category] = {
                            ...newCart[category],
                            [product.name]: productEntry
                        }
                    }
                } else {
                    delete newCart[category][product.name];

                }
            }

            StorageService.setItem(LOCALSTORAGE_ITEMS.CURRENT_CART, JSON.stringify(newCart));

            setState({
                ...state,
                currentCart: newCart
            })
        };
    }

    const openModal = () => {
        setState({
            ...state,
            currentStyle: visible
        })
    }
    const closeModal = () => {
        setState({
            ...state,
            currentStyle: hidden
        })
    }

    const handleCashButton = () => {
        if (buttonClicked) {
            return;
        }
        buttonClicked = true;
        closeModal();
        checkoutProductsOrder("CASH").then(r => {
            buttonClicked = false;
        });
    }

    const handleCardButton = () => {
        if (buttonClicked) {
            return;
        }
        buttonClicked = true;
        closeModal();
        checkoutProductsOrder("CARD").then(r => {
            buttonClicked = false;
        });
    }


    const createGroupOrder = async () => {
        if (!state.isSubmitBtnEnabled) {
            return;
        }
        setState({
            ...state,
            loading:true,
            isSubmitBtnEnabled:false
        })
        const bodyForCreateGroupOrder = {
            "shop": StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
            "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "table": userTable,
            "place": orderPlace,
            "procStatus": procStatuses.OPEN,
            "name": userInfo ? userInfo.firstName + " " +  userInfo.lastName: StorageService.getItem(LOCALSTORAGE_ITEMS.USER_INFO_ANONYMOUS.firstName),
            // "address":"SSSS",
            // "contact":"0743547720",
            // "pickupDate": "2024-01-15T15:30:00Z",
            // "pickupTime":"22:33"
        }

        const bodyForGetGroupOrder = {
            "shop": StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
            "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "table": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TABLE),
            "procStatus": [procStatuses.OPEN],
            "goid": StorageService.getItem(LOCALSTORAGE_ITEMS.GROUP_ORDER_ID)

        }

        const bodyForUpsert = {
            "shop": StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
            "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "name": userInfo && userInfo.firstName && userInfo.lastName ? userInfo.firstName + " " + userInfo.lastName : userInfoAnonymous.user.firstName,
            "confirmed": true,
            "oid": StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID),
            "products": getProductsOrderFromCart(state.currentCart).flatMap(product => {
                return product.choices.map(choice => {
                    return {
                        "pid": product.pid,
                        "quantity": choice.quantity,
                        "msg": choice.msg ? choice.msg : null,
                        "option": choice.option ? choice.option : null,
                        "extras": choice.extras.length > 0 ? choice.extras.map(e => e.pid) : null
                    }
                });
            })
        }

        const allGroupOrdersResponse = await getAllGroupedOrdersHandler(bodyForGetGroupOrder);
        if (allGroupOrdersResponse.data.groupedOrder.length === 0) {
            const response = await createGroupedOrdersHandler(bodyForCreateGroupOrder);
            console.log("createGroupedOrdersHandler response", response);
            if (response.data.groupedOrder && response.data.error === null) {
                StorageService.setItem(LOCALSTORAGE_ITEMS.GROUP_ORDER_ID, response.data.groupedOrder.goid);
                bodyForUpsert.goid = response.data.groupedOrder.goid;
                await upsertGroupProductsOrderHandler(bodyForUpsert);
                navigateTo(PATH.GROUP_ORDER_REVIEW + "/" + response.data.groupedOrder.goid);
            } else {
                //error handling
                if (response.data.error === "26") {
                    setState({
                        ...state,
                        errorMsg: <FormattedMessage id="Error.groupOrderAlreadyCreated"
                                                    defaultMessage="Error.groupOrderAlreadyCreated"/>
                    })
                } else {
                    setState({
                        ...state,
                        errorMsg: <FormattedMessage id="Error.genericError" defaultMessage="Error.genericError"/>
                    })
                }
            }
        } else {
            bodyForUpsert.goid = allGroupOrdersResponse.data.groupedOrder[0].goid;
            await upsertGroupProductsOrderHandler(bodyForUpsert);
            StorageService.setItem(LOCALSTORAGE_ITEMS.GROUP_ORDER_ID, allGroupOrdersResponse.data.groupedOrder[0].goid);
            navigateTo(PATH.GROUP_ORDER_REVIEW + "/" + bodyForUpsert.goid);
        }

    }

    const handleSubmit = () => {

        if (isBarPickup && orderPlace === ORDER_PLACE.BAR) {
            openModal();
        } else {
            checkoutProductsOrder();
        }
    }

    const checkoutProductsOrder = async (chosenPaymentMethod) => {
        let response = null;
        setState({
            ...state,
            isSubmitBtnEnabled: false,
            loading: true,
            currentStyle: hidden
        })

        if (!state.isSubmitBtnEnabled || state.loading) {
            return;
        }

        if (StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID)) {
            response = await changeOrder();
            if (!response.ok && response.data.code === 409) { //"DELIVERED!=OPEN"
                EventBus.dispatch("waiterClosedTheOrder");
            }
        } else {
            response = await sendOrder(chosenPaymentMethod);
            if (response.ok) {
                StorageService.setItem(LOCALSTORAGE_ITEMS.ORDER_ID, response.data.oid);
            }
        }

        if (response.ok) {
            StorageService.removeItem(LOCALSTORAGE_ITEMS.CURRENT_CART);
            setState({
                ...state,
                isSubmitBtnEnabled: true,
                loading: false,
            })

            if (isBarPickup && orderPlace === ORDER_PLACE.BAR && !userTable) {
                navigateTo(PATH.BAR_THANK_YOU + "/" + StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID))
            } else {
                navigateTo(PATH.ORDER_SUMMARY);
            }

        } else if (response.data.internalCode === "19" || response.data.internalCode === "28") { // product out of stock
            const outOfStockProductPid = [];
            for (const property in state.currentCart) {
                for (const productName in state.currentCart[property]) {
                    if (state.currentCart[property][productName].sku === response.data.internalMsg) {
                        outOfStockProductPid.push(state.currentCart[property][productName].pid)
                    }
                }
            }
            setState({
                ...state,
                loading: false,
                errorMsg: <FormattedMessage id="SomeProductsJustWentOutOfStock"/>,
                outOfStockProducts: outOfStockProductPid
            })
        } else if (response.data.internalCode === "32" || response.data.internalCode === "33") { // extra product out of stock
            const outOfStockProductPid = [];
            for (const property in state.currentCart) {
                for (const productName in state.currentCart[property]) {
                    const p = state.currentCart[property][productName];
                    p.choices.forEach(c => {
                        if (c.extras) {
                            c.extras.forEach(extra => {
                                if (extra.sku === response.data.internalMsg) {
                                    outOfStockProductPid.push(extra.pid);
                                }
                            });
                        }
                    });
                }
            }
            setState({
                ...state,
                loading: false,
                errorMsg: <FormattedMessage id="SomeProductsJustWentOutOfStock"/>,
                outOfStockExtras: outOfStockProductPid
            });
        } else if (response.data.internalCode === "20") { // Invalid table
            setState({
                ...state,
                loading: false,
                errorMsg: <FormattedMessage id="InvalidTablePleaseContactWaiter"/>,
            })
        } else {
            setState({
                ...state,
                isSubmitBtnEnabled: true,
                loading: false,
                genericError: true
            });

        }
    }


    const sendOrder = async (chosenPaymentMethod) => {

        const body = {
            "shop": StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
            "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "clientApp": "WEB_ORDERING",
            "place": isBarPickup && orderPlace === ORDER_PLACE.BAR ? ORDER_PLACE.BAR : ORDER_PLACE.TABLE,
            "table": userTable,
            "paymentMethod": chosenPaymentMethod || null,
            "products": getProductsOrderFromCart(state.currentCart).flatMap(product => {

                return product.choices.map(choice => {
                    return {
                        "pid": product.pid,
                        "quantity": choice.quantity,
                        "msg": choice.msg ? choice.msg : null,
                        "option": choice.option ? choice.option : null,
                        "extras": choice.extras.length > 0 ? choice.extras.map(e => e.pid) : null
                    }
                });
            })
        }

        const response = await ProductService.createProductsOrder(body);

        return response;

    }

    const changeOrder = async () => {
        const body = {

            "shop": StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
            "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "oid": StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID),
            "place": "TABLE",
            "table": userTable,
            "products": getProductsOrderFromCart(state.currentCart).flatMap(a => {
                return a.choices.map(c => {
                    return {
                        "pid": a.pid,
                        "quantity": c.quantity,
                        "msg": c.msg ? c.msg : null,
                        "option": c.option ? c.option : null,
                        "extras": c.extras.length > 0 ? c.extras.map(e => e.pid) : null
                    }
                });
            })
        }

        const response = await ProductService.changeProductsOrder(body);

        return response;
    }

    const getEstimatedPickupTime = () => {
        return <Moment
            format={DATE_FORMAT.HOUR_MINUTES}
            date={addMinutes(new Date(), timeForBarPickup)}
        />
    }

    const toUpdatePhone = () => {
        navigateTo(PATH.PROFILE_UPDATE_PHONE);
    }

    if ((state.currentCart && isBarPickup === true) || (userTable && state.currentCart && !isBarPickup)) {
        return (
            <>
                <Header
                    headerSize={HEADER_SIZE.SMALL}
                    headerTitle={<FormattedMessage id="OrderReview"/>}
                    hasBackBtn={true}
                    hasModal={true}
                />

                {/*START PAGE-CONTENT*/}
                <main className="page-content">
                    <div className={state.currentStyle + " modal-overlay "} onClick={(e) => closeModal()}></div>
                    <div data-qa="modal" className="modal">
                        <div className="row">
                            <div className="modal-title"><FormattedMessage id="ChoosePaymentMethod"/></div>
                        </div>


                        <div data-qa="order-review-buttons-row" className="row buttons-row">
                            {orderPlace && orderPlace === ORDER_PLACE.BAR && allowedPaymentMethodsForBarPickup?.includes(PAYMENT_TYPES.CASH) &&
                                <a data-qa="order-review-popup-btn" className=" btn btn-outlined btn-md" id="CASH"
                                   onClick={handleCashButton}><FormattedMessage id="Cash"/></a>
                            }

                            {orderPlace && orderPlace === ORDER_PLACE.BAR && allowedPaymentMethodsForBarPickup?.includes(PAYMENT_TYPES.CARD) &&
                                <a data-qa="order-review-popup-btn" className="btn btn-outlined btn-md" id="CARD"
                                   onClick={handleCardButton}><FormattedMessage id="Card"/></a>
                            }


                            {orderPlace && orderPlace === ORDER_PLACE.TABLE && allowedPaymentMethodsForTableOrder?.includes(PAYMENT_TYPES.CASH) &&
                                <a data-qa="order-review-popup-btn" className=" btn btn-outlined btn-md" id="CASH"
                                   onClick={handleCashButton}><FormattedMessage id="Cash"/></a>
                            }

                            {orderPlace && orderPlace === ORDER_PLACE.TABLE && allowedPaymentMethodsForTableOrder?.includes(PAYMENT_TYPES.CARD) &&
                                <a data-qa="order-review-popup-btn" className="btn btn-outlined btn-md" id="CARD"
                                   onClick={handleCardButton}><FormattedMessage id="Card"/></a>
                            }


                        </div>
                    </div>
                    <div className="order-details-top-msg">

                        {isBarPickup && timeForBarPickup && !userTable ?
                            <>

                                <FormattedMessage id="EstimatedPickupTime"/>
                                &nbsp;
                                <span>{getEstimatedPickupTime(timeForBarPickup)}</span>
                            </>
                            : <>
                                <FormattedMessage id="YourOrderWillBeDelivered"/>
                                <span className="order-details-table">&nbsp;{userTable}</span>
                            </>

                        }


                    </div>


                    {/*START ORDER DETAILS*/}
                    <section className="order-details-card">
                        <div className="card-content">
                            {getProductsOrderFromCart(state.currentCart)?.map((product, productIndex) =>
                                <div key={"productIndex" + productIndex}>
                                    {product.choices?.map((choice, choiceIndex) =>
                                        choice.msg || choice.option || choice.extras?.length > 0 ?
                                            <div key={choiceIndex}
                                                 className="product with-choices with-quantity-modifier">
                                                <div className="row">
                                                    <QuantityModifier
                                                        onlyLoggedUser={false}
                                                        quantity={choice.quantity}
                                                        increaseQuantity={state.isSubmitBtnEnabled ? increaseQuantity(product, choice) : void (0)}
                                                        decreaseQuantity={state.isSubmitBtnEnabled ? decreaseQuantity(product, choice) : void (0)}
                                                    />
                                                    <span
                                                        className={state.outOfStockProducts?.includes(product.pid) ? "prod-name danger ml-0" : "prod-name ml-0"}>
                                                            {getProdName(product)}
                                                        </span>
                                                    <span className="prod-price">&nbsp;
                                                        <IntlProvider
                                                            locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                                                                <FormattedNumber
                                                                    value={choice.price / 100.0}
                                                                    style="currency"
                                                                    minimumFractionDigits={2}
                                                                    maximumFractionDigits={2}
                                                                    currency={currency}/>
                                                             </IntlProvider>
                                                        </span>
                                                </div>

                                                <div className="choices row">

                                                    {choice.option ?
                                                        <span>
                                                                    {getProdOptionsFromCart(choice)}
                                                            &nbsp;</span>
                                                        : null
                                                    }
                                                    {choice.msg ?
                                                        <span>({choice.msg})&nbsp;</span>
                                                        : null
                                                    }
                                                </div>
                                                <div className="choices row">
                                                    {choice.extras ?
                                                        <>
                                                            {getProdExtrasFromCart(choice, state.outOfStockExtras)}
                                                        </>
                                                        : null
                                                    }
                                                </div>
                                            </div>
                                            :
                                            <div key={productIndex + product}
                                                 className="product with-quantity-modifier"
                                                 data-qa="product with-quantity-modifier">
                                                <div className="row">
                                                    <QuantityModifier
                                                        onlyLoggedUser={false}
                                                        quantity={choice.quantity}
                                                        increaseQuantity={state.isSubmitBtnEnabled ? increaseQuantity(product, choice) : void (0)}
                                                        decreaseQuantity={state.isSubmitBtnEnabled ? decreaseQuantity(product, choice) : void (0)}
                                                    />
                                                    <span
                                                        className={state.outOfStockProducts?.includes(product.pid) ? "prod-name danger ml-0" : "prod-name ml-0"}>
                                                            {getProdName(product)}
                                                        </span>
                                                    <span className="prod-price">&nbsp;
                                                        <IntlProvider
                                                            locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                                                                 <FormattedNumber
                                                                     value={
                                                                         choice.price / 100.0}
                                                                     style="currency"
                                                                     minimumFractionDigits={2}
                                                                     maximumFractionDigits={2}
                                                                     currency={currency}/>
                                                                 </IntlProvider>
                                                        </span>
                                                </div>
                                            </div>
                                    )}
                                </div>
                            )}
                            <div className="total-container row">
                    <span className="total-prod-nr" data-qa="order-review-total-prod-nr">
                        {getTotalProducts(getProductsOrderFromCart(state.currentCart))}
                        &nbsp;</span>
                                <span
                                    className="total-prod-label">{getTotalProducts(getProductsOrderFromCart(state.currentCart)) !== 1 ?
                                    <FormattedMessage id="Products"/> : <FormattedMessage id="Product"/>}</span>
                                <span className="total-price" data-qa="order-review-total-price"
                                      data-qa-value={getTotalPrice(getProductsOrderFromCart(state.currentCart)) / 100.0}>
                         <IntlProvider locale={StorageService.getItem(LOCALSTORAGE_ITEMS.LOCALE)}>
                         <FormattedNumber
                             value={getTotalPrice(getProductsOrderFromCart(state.currentCart)) / 100.0}
                             style="currency"
                             minimumFractionDigits={2}
                             maximumFractionDigits={2}
                             currency={currency}/>
                         </IntlProvider>
                    </span>
                            </div>

                        </div>
                    </section>

                    {/*START ORDER DETAILS*/}
                    {orderPlace === ORDER_PLACE.BAR && <section className="order-details-card">
                        <header className="order-details-card-header neutral">
                            <FormattedMessage id="ContactInformation"/>
                        </header>
                        <div className="form-group">


                            {userInfo?.phone && <div className="row">
                                <label>{<FormattedMessage id="PhoneNo"/>}</label>
                                <input
                                    type="text"
                                    onFocus={() => toUpdatePhone()}
                                    onClick={() => toUpdatePhone()}
                                    maxLength={20}
                                    readOnly={true}
                                    value={userInfo?.phone}
                                    autoComplete="off"
                                />
                            </div>}
                        </div>
                    </section>}

                    {state.errorMsg != null ? <div className="error-div">&#9888;&nbsp;{state.errorMsg}</div> : null}
                </main>
                {/*END PAGE-CONTENT*/}

                {groupOrderIdInStorage ?
                    <OrderReviewActionsBar

                        isVisible={true}
                        buttonName={<FormattedMessage id="UpdateGroupOrder"/>}
                        dataQAIdentifier={"order-review-submit-btn"}
                        btnClassName={state.isSubmitBtnEnabled ? "btn btn-default btn-xl" : "btn btn-default btn-xl btn-disabled"}
                        buttonAction={() => {
                            state.isSubmitBtnEnabled ? createGroupOrder() : void (0);
                        }}


                    />
                    :

                    <OrderReviewActionsBar

                        isVisible={true}
                        buttonName={<FormattedMessage id="OrderAsGroup"/>}
                        dataQAIdentifier={"order-review-submit-btn"}
                        btnClassName={state.isSubmitBtnEnabled ? "btn btn-default btn-md" : "btn btn-default btn-md btn-disabled"}
                        buttonAction={() => {
                            state.isSubmitBtnEnabled ? createGroupOrder() : void (0);
                        }}
                        buttonName2={hasGroupOrdering ? <FormattedMessage id="SendMyOrder"/> :
                            <FormattedMessage id="SendOrder"/>}
                        dataQAIdentifier2={"order-review-submit-btn"}
                        btnClassName2={state.isSubmitBtnEnabled ? "btn btn-default btn-md" : "btn btn-default btn-md btn-disabled"}
                        buttonAction2={() => {
                            state.isSubmitBtnEnabled ? handleSubmit() : void (0);
                        }}

                    />
                }


                {state.loading ?
                    <div className="spinner" data-qa="spinner"><Spinner/></div>
                    : null
                }
            </>
        )
    } else {
        return (
            <ScanQrToContinue/>
        )
    }

}

export default OrderReview;
